import { render, staticRenderFns } from "./_gameinfo.vue?vue&type=template&id=855cc3ba&scoped=true&"
import script from "./_gameinfo.vue?vue&type=script&lang=js&"
export * from "./_gameinfo.vue?vue&type=script&lang=js&"
import style0 from "./_gameinfo.vue?vue&type=style&index=0&id=855cc3ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855cc3ba",
  null
  
)

export default component.exports